export enum ColumnType{
	TEXT = 'TEXT',
	BOOLEAN = 'BOOLEAN',
	NUMBER = 'NUMBER',
	DATE = 'DATE',
	FILE_SIZE = 'FILE_SIZE',
	PROGRESS = 'PROGRESS',
	TREATMENTS_INFO = 'TREATMENTS_INFO',
	CUSTOM = 'CUSTOM',
	DATE_TEXT = 'DATE_TEXT',
}
